import type {QueryClient} from '@tanstack/react-query';

/**
 * CO-3 — event-triggered refreshes for the two classroom polls, fired from the
 * root's WS handlers and ActivePuzzle's own-solve callback instead of relying
 * purely on the (now slower) interval polls.
 *
 * `refreshLeaderboardSoon` invalidates by the bare `['classroomLiveAttempts']`
 * prefix (no meetingId/occurenceId/puzzleId) because the root's WS handlers
 * close over those ids from mount and can go stale across a puzzle change —
 * a prefix invalidation reaches whichever variant is currently mounted. The
 * delay (4-6s) is deliberate: the server caches live attempts for 3s per
 * class+puzzle (CO-4), so firing immediately on the WS event would often just
 * re-read the stale cache.
 *
 * `refreshRecognitionSoon` invalidates `['studentRecognitionState']` with a
 * much shorter 0-2s jitter only, since that endpoint isn't server-cached —
 * the jitter exists purely to spread out a whole-class burst (e.g. an
 * end-of-class celebration) instead of everyone invalidating in the same tick.
 */
export function refreshLeaderboardSoon(queryClient: QueryClient): void {
  setTimeout(() => {
    queryClient.invalidateQueries(['classroomLiveAttempts']);
  }, 4000 + Math.random() * 2000);
}

export function refreshRecognitionSoon(queryClient: QueryClient): void {
  setTimeout(() => {
    queryClient.invalidateQueries(['studentRecognitionState']);
  }, Math.random() * 2000);
}
